import type { User } from '@mimir/web/model/User';
import { type MenuItems, type StoreType, MenuItemKeys } from './state';
import { FolderKind } from '@mimir/common/dto/folderModels';
export { supportedOps } from '@mimir/common/util/item';
import type { ClientConfig } from '@mimir/common/dto/ClientConfigDto';
import type { Storages } from '@mimir/common/dto/storageModel';
import { AccountStatus } from '@mimir/common/dto/userDto';
import { invariant } from '@mimir/common/util/invariant';
import { setCurrentFolder } from '../globals/folders';

/**
 * When the user clicks on search, it should be treated as a fresh search.
 */
export function clearNavigationParams(store: StoreType) {
  setCurrentFolder(null);
  return store.dispatch('clearAllFilters');
}

/**
 * The order in this const determines the order the UI is drawing them.
 */
export const sideBarItems: MenuItems = {
  'Filter': {
    icon: 'filter_alt',
    key: MenuItemKeys.Filter,
    routePath: '/search-item',
    childRoutes: ['searchItem', 'itemDetails'],
    isVisible: true,
    onClick: (store: StoreType) => {
      invariant(store, 'Search onClick called without store parameter');
      clearNavigationParams(store).catch(ex => console.error('Search onClick', ex));
    },
  },
  'Folders': {
    icon: 'folder_shared',
    key: MenuItemKeys.Folders,
    routePath: '/folders',
    routeQuery: () => ({ folderId: FolderKind.TenantRoot }),
    childRoutes: [],
    rightIcon: 'add',
    onRightIconClick: () => { }, // handled in FolderMenuItem
    isVisible: true,
  },
  'Bookmarks': {
    icon: 'bookmarks',
    key: MenuItemKeys.Bookmarks,
    routePath: '',
    rightIcon: 'add',
    childRoutes: [],
    isVisible: true,
  },
  'Local': {
    icon: 'hard_drive',
    key: MenuItemKeys.Local,
    routePath: '/local',
    childRoutes: [],
    isVisible: true,
  },
  'Share': {
    icon: 'share',
    key: MenuItemKeys.Share,
    routePath: '/share',
    childRoutes: [],
    isVisible: true
  },
  'Tasks': {
    icon: 'task',
    key: MenuItemKeys.Tasks,
    routePath: '/userTasks',
    childRoutes: [],
    isVisible: true
  },
  'Projects': {
    icon: 'file_open',
    key: MenuItemKeys.Projects,
    routePath: '',
    childRoutes: [],
    isVisible: true,
  },

  // TODO: Remove the following two items when the 'newTabsAndCutter' feature flag is removed
  // as they have been moved to the new tabs.
  'Activity': {
    icon: 'trending_up',
    key: MenuItemKeys.Activity,
    routePath: '/activity',
    childRoutes: [],
    isVisible: true
  },
  'Scheduler': {
    icon: 'calendar_today',
    key: MenuItemKeys.Scheduler,
    routePath: '/scheduler',
    childRoutes: [],
    isVisible: true
  },

  'Premiere': {
    iconImagePath: 'premiere-logo',
    key: MenuItemKeys.Premiere,
    routePath: '/premiere',
    childRoutes: [],
    isVisible: false,
  },
  'DVR': {
    iconImagePath: 'dvr-logo.png',
    key: MenuItemKeys.DVR,
    routePath: '/premiere',
    childRoutes: [],
    isVisible: false,
  },
  'RecycleBin': {
    icon: 'delete',
    key: MenuItemKeys.RecycleBin,
    routePath: '/recycle-bin',
    childRoutes: [],
    routeQuery: { showOnlyDeletedItems: true },
    isVisible: true,
  },
};

export const storage: Storages = {
  default: undefined,
  all: []
};

export const clientConfig: Partial<ClientConfig> = {};

export const loggedInUser: User = {
  id: '',
  groups: [],
  accountStatus: AccountStatus.Unknown,
  familyName: '',
  givenName: '',
  email: '',
  emailVerified: false,
  permissions: [],
  userId: '',
  tenantId: '',
  roles: {
    superAdmin: false,
    tenantAdmin: false,
    supportTeam: false,
  },
  extGroupsHint: [],
  primaryGroupKeldaIdForConformLocation: undefined,
  primaryGroupRenderDelegateForMimirCutter: undefined,
  primaryGroupDefaultBookmarkId: undefined,
  primaryGroupDefaultVisibleTo: undefined,
  primaryGroupDefaultUpdatableBy: undefined,
  isSoftwareTokenMfaEnabled: undefined,
};
